import { Callback } from "../../../modules/types"

export type DiagsState = {
  alert: {
    open: boolean
    text: string
    title: string
  },
  confirm: {
    open: boolean
    text: string
    title?: string
    confirmText?: string
    callback: Callback
  },
  lastError?: ErrorInfo
  lastErrorHandled: boolean
  appLoading: boolean
}

export const initialDiagsState: DiagsState = {
  alert: {
    open: false,
    text: '',
    title: '',
  },
  confirm: {
    open: false,
    text: '',
    title: '',
    callback: () => {
      // do nothing
    }
  },
  lastErrorHandled: false,
  appLoading: true
}


export type ErrorInfo = {
  id: string
  fromApi: boolean
  httpStatus?: number
  errorCode?: string
  error?: Error
}